import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { ConversationMessageKey } from 'flow/types/TicketEventData';
import { TicketKey } from 'flow/types/EntityKeys';
import { isTypeExtensionKey } from 'flow/utils/extension-utils-TW';
import {
    selectEventSender,
    selectEventSenderType,
} from 'flow/selectors/TicketEventSelectors';
import PhoneNumber from 'flow/components/ui-components/PhoneNumber';
import SenderExtension from './event-item/Messages/SenderExtension';
import SenderExternal from './event-item/Messages/SenderExternal';
import SenderSystem from './event-item/Messages/SenderSystem';

interface Props {
    ticketKey: TicketKey;
    messageKey: ConversationMessageKey;
}

const MessageSender = ({ ticketKey, messageKey }: Props) => {
    const sender = useAppSelector((state) =>
        selectEventSender(state, ticketKey, messageKey),
    );
    const senderType = useAppSelector((state) =>
        selectEventSenderType(state, ticketKey, messageKey),
    );

    const getBody = () => {
        if (senderType === 'ACCOUNT' && isTypeExtensionKey(sender)) {
            return <SenderExtension sender={sender} />;
        }

        if (senderType === 'EXTERNAL') {
            return (
                <SenderExternal ticketKey={ticketKey} messageKey={messageKey} />
            );
        }

        if (senderType === 'SYSTEM') {
            return <SenderSystem />;
        }

        return <PhoneNumber number={sender} />;
    };

    return (
        <div className="flex items-center text-sm/4 font-bold">{getBody()}</div>
    );
};

export default MessageSender;
